import { handleActions } from 'redux-actions';
import {
  elementFormulaListLoaded,
  elementFormulaListError,
  removeElementFromFormulaTabFromSocketPayloadAction,
  addFormulaToFormulaListFromSocketPayloadAction,
  updateFormulaListElementsFromSocketPayloadAction,
} from 'store/actions/element-panel-actions';
import {
  elementFormulaListLoading,
  deleteFormulaError,
  elementFormulaListLoadedWithoutResponse,
} from 'store/actions/common/element-panel-actions';
import { FormulaList } from 'models/api/formula-list-model';

export default handleActions(
  {
    [elementFormulaListLoading]: (formulaList) => {
      return formulaList.setLoading();
    },
    [elementFormulaListLoaded]: (formulaList, { payload }) => {
      return formulaList.setLoaded(payload);
    },
    [elementFormulaListLoadedWithoutResponse]: (formulaList) => {
      return formulaList.setLoadedWithoutResponse();
    },
    [elementFormulaListError]: (formulaList, { payload }) => {
      return formulaList.setError(payload);
    },
    [deleteFormulaError]: (formulaList, { payload }) => {
      return formulaList.setError(payload);
    },
    [removeElementFromFormulaTabFromSocketPayloadAction]: (
      formulaList,
      { payload },
    ) => {
      return formulaList.removeElementFromFormulaTabFromSocketPayload(payload);
    },
    [addFormulaToFormulaListFromSocketPayloadAction]: (
      formulaList,
      { payload },
    ) => {
      return formulaList.addFormulaToFormulaListFromSocketPayload(payload);
    },
    [updateFormulaListElementsFromSocketPayloadAction]: (
      formulaList,
      { payload },
    ) => {
      return formulaList.updateFormulaListElementsFromSocketPayload(payload);
    },
  },
  new FormulaList(),
);
